import styled from 'styled-components';

export const SortingWrapper = styled.div`
  margin: 24px 0;
  gap: 24px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;

export const Legend = styled.div`
  display: grid;
  grid-template-columns: 96px 2fr repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;

  h4 {
    color: #515151;
    text-transform: uppercase;
  }

  @media ${(props) => props.theme.device.tabletL} {
    grid-template-columns: 96px 2fr repeat(2, 1fr) 120px;
  }
`;

export const CourseCard = styled(Legend)`
  padding: 24px 0;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  margin-left: 16px;
  margin-right: 16px;

  .code {
    padding-left: 24px;
  }
`;

export const CourseCardMobile = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px 8px;
  padding: 16px 0 28px;
  margin: 0 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  align-items: center;

  > *:nth-child(even) {
    justify-self: flex-end;
    text-align: right;
  }

  .b4,
  .b5 {
    color: #515151;
  }

  h5 {
    color: #646464;
    text-transform: uppercase;
  }
`;
